export enum SearchMeditatorActions {
    REGISTERATION = "register",
    CANCELLATION_REQUEST = "decline",
}